import { Language } from '../context/LanguageContext';
import { getLocalizedJewelleryCollectionItems, JewelleryCollectionItemView } from '../utils/jewelleryCollectionUtils';

export function getTourmalineCollectionItems(language: Language): JewelleryCollectionItemView[] {
    return getLocalizedJewelleryCollectionItems('tourmaline', language);
}
